import React from 'react';

const DateFormatter = ({ 
    date, 
    format = 'full', 
    showTime = true, 
    className = '',
    style = {} 
}) => {
    if (!date) return <span className={className} style={style}>-</span>;

    const dateObj = new Date(date);
    
    // Check if date is valid
    if (isNaN(dateObj.getTime())) {
        return <span className={className} style={style}>Invalid Date</span>;
    }

    const formatDate = (dateObj, format, showTime) => {
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        const shortMonths = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];

        const day = dateObj.getDate();
        const month = dateObj.getMonth();
        const year = dateObj.getFullYear();
        const hours = dateObj.getHours();
        const minutes = dateObj.getMinutes();

        // Format time
        const timeStr = showTime ? 
            ` at ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}` : 
            '';

        switch (format) {
            case 'full':
                return `${day} ${months[month]} ${year}${timeStr}`;
            case 'short':
                return `${day} ${shortMonths[month]} ${year}${timeStr}`;
            case 'compact':
                return `${day}/${month + 1}/${year}${timeStr}`;
            case 'dateOnly':
                return `${day} ${months[month]} ${year}`;
            case 'shortDateOnly':
                return `${day} ${shortMonths[month]} ${year}`;
            case 'monthYear':
                return `${months[month]} ${year}`;
            case 'dayMonth':
                return `${day} ${months[month]}`;
            default:
                return `${day} ${months[month]} ${year}${timeStr}`;
        }
    };

    const formattedDate = formatDate(dateObj, format, showTime);

    return (
        <span className={className} style={style} title={dateObj.toLocaleString()}>
            {formattedDate}
        </span>
    );
};

// Additional utility functions that can be exported
export const formatDate = (date, format = 'full', showTime = true) => {
    if (!date) return '-';
    
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return 'Invalid Date';
    
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const shortMonths = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const day = dateObj.getDate();
    const month = dateObj.getMonth();
    const year = dateObj.getFullYear();
    const hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();

    const timeStr = showTime ? 
        ` at ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}` : 
        '';

    switch (format) {
        case 'full':
            return `${day} ${months[month]} ${year}${timeStr}`;
        case 'short':
            return `${day} ${shortMonths[month]} ${year}${timeStr}`;
        case 'compact':
            return `${day}/${month + 1}/${year}${timeStr}`;
        case 'dateOnly':
            return `${day} ${months[month]} ${year}`;
        case 'shortDateOnly':
            return `${day} ${shortMonths[month]} ${year}`;
        case 'monthYear':
            return `${months[month]} ${year}`;
        case 'dayMonth':
            return `${day} ${months[month]}`;
        default:
            return `${day} ${months[month]} ${year}${timeStr}`;
    }
};

// Get relative time (e.g., "2 hours ago", "3 days ago")
export const getRelativeTime = (date) => {
    if (!date) return '-';
    
    const now = new Date();
    const dateObj = new Date(date);
    const diffInMs = now - dateObj;
    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
    if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
    if (diffInDays < 7) return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
    
    // For older dates, return formatted date
    return formatDate(date, 'shortDateOnly', false);
};

export default DateFormatter; 